<template>
  <div class="content">
    <div style="display: flex; justify-content: center; font-size: 18px; margin-top: 40px; color: #b3adad; margin-bottom: 20px;">
      {{ appInfo.name }} - 忘记密码
    </div>

    <div style="margin: 30px;">
      <a-spin :spinning="loading">
        <div style="margin-top: 15px;" v-if="isTenant">
          <a-input placeholder="请输入企业域"
                   size="large"
                   v-model="forgetPassword.tenant"
                   @input="handleTenantInput">
            <a-icon slot="prefix" type="home"></a-icon>
          </a-input>
        </div>
        <div style="margin-top: 15px;">
          <a-input placeholder="请输入手机号"
                   size="large"
                   v-model="forgetPassword.phone">
            <a-icon slot="prefix" type="mobile"></a-icon>
          </a-input>
        </div>
        <div style="margin-top: 15px; display: flex;">
          <a-input placeholder="请输入验证码"
                   size="large"
                   v-model="forgetPassword.code">
            <a-icon slot="prefix" type="message"></a-icon>
          </a-input>
          <a-button type="link" style="margin-top: 5px; width: 120px;" :disabled="resetPwdTimer > 0 && resetPwdTimer !== 60" @click="sendResetCode">
            {{ (resetPwdTimer === 0 || resetPwdTimer === 60) ? '获取验证码' : '重新发送(' + resetPwdTimer + ')' }}
          </a-button>
        </div>
        <div style="margin-top: 15px;">
          <a-input-password placeholder="请输入新密码"
                            size="large"
                            type="password"
                            v-model="forgetPassword.newPassword">
            <a-icon slot="prefix" type="lock"></a-icon>
          </a-input-password>
        </div>
        <div style="margin-top: 15px;">
          <a-input-password placeholder="请再次输入新密码"
                            size="large"
                            type="password"
                            v-model="forgetPassword.confirmPassword">
            <a-icon slot="prefix" type="lock"></a-icon>
          </a-input-password>
        </div>

        <div style="margin-top: 25px; display: flex; justify-content: space-between;">
          <a-button style="width: 48%;" @click="goBack">
            返回登录
          </a-button>
          <a-button style="width: 48%;"
                    type="primary"
                    @click="resetPassword">
            确认重置
          </a-button>
        </div>

        <div style="margin-top: 25px; text-align: center;" v-if="errorMsg">
          <span style="text-align: center; color: #e75353; font-size: 14px; ">
            {{ errorMsg }}
          </span>
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      errorMsg: state => state.login.data.errorMsg,
      error: state => state.login.data.error,
      loading: state => state.login.data.loading,
      forgetPassword: state => state.login.forgetPassword,
      appInfo: state => state.login.data.appInfo,
      isTenant: state => state.login.data.isTenant,
      resetPwdTimer: state => state.login.data.resetPwdTimer,
    }),
  },

  created() {
    this.$store.dispatch('init');
    this.$store.dispatch('getAppInfo');
  },

  methods: {
    goBack() {
      // 获取当前URL的query参数
      const query = this.$route.query;
      // 返回登录页面，带上完整的query参数
      this.$router.push({
        path: '/login',
        query: query
      });
    },

    sendResetCode() {
      this.$store.dispatch('sendResetCode', this).then(() => {
        this.$store.dispatch('triggerCaptcha').then((res) => {
          if (res) {
            this.$store.dispatch('getCaptcha');
          }
        });
      });
    },

    resetPassword() {
      this.$store.dispatch('resetPassword', this).then(() => {
        // 获取当前URL的query参数
        const query = this.$route.query;
        // 返回登录页面，带上完整的query参数
        this.$router.push({
          path: '/login',
          query: query
        });
      });
    },

    handleTenantInput() {
      if (this.forgetPassword.tenant) {
        this.forgetPassword.tenant = this.forgetPassword.tenant.toUpperCase();
      }
    },
  }
};
</script>

<style lang="less" scoped>
.content {
  background-color: #fff;
  border-radius: 10px;
  width: 420px;
  min-height: 470px;
  box-shadow: 0 14px 28px #cdc5c5, 0 10px 10px #cdc5c5;
}
</style>
